// // import { useCallback } from 'react';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { setUser, setToken, setLoading, setError, logout as logoutAction } from '../store/slices/authSlice';
// // import { authService } from '../api/services/auth.service';

// // export const useAuth = () => {
// //     const dispatch = useDispatch();
// //     const { user, token, isAuthenticated, loading, error } = useSelector((state) => state.auth);

// //     const login = useCallback(
// //         async (credentials) => {
// //             try {
// //                 dispatch(setLoading(true));
// //                 dispatch(setError(null));
// //                 const response = await authService.login(credentials);
// //                 dispatch(setToken(response.token));
// //                 dispatch(setUser(response.user));
// //                 return { success: true };
// //             } catch (err) {
// //                 dispatch(setError(err.message || 'Login failed'));
// //                 return { success: false, error: err.message };
// //             } finally {
// //                 dispatch(setLoading(false));
// //             }
// //         },
// //         [dispatch]
// //     );

// //     const logout = useCallback(async () => {
// //         try {
// //             await authService.logout();
// //         } catch {
// //             // Ignore logout errors
// //         } finally {
// //             dispatch(logoutAction());
// //         }
// //     }, [dispatch]);

// //     const checkAuth = useCallback(() => {
// //         const storedToken = localStorage.getItem('authToken');
// //         if (storedToken && !isAuthenticated) {
// //             dispatch(setToken(storedToken));
// //         }
// //     }, [dispatch, isAuthenticated]);

// //     return {
// //         user,
// //         token,
// //         isAuthenticated,
// //         loading,
// //         error,
// //         login,
// //         logout,
// //         checkAuth,
// //     };
// // };
// import { useCallback } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//     setUser,
//     setToken,
//     setLoading,
//     setError,
//     logout as logoutAction,
// } from '../store/slices/authSlice';
// import { authService } from '../api/services/auth.service';

// export const useAuth = () => {
//     const dispatch = useDispatch();
//     const { user, token, isAuthenticated, loading, error } = useSelector((state) => state.auth);

//     const login = useCallback(
//         async (credentials) => {
//             try {
//                 dispatch(setLoading(true));
//                 dispatch(setError(null));

//                 const response = await authService.login(credentials);

//                 dispatch(setToken(response.token));
//                 dispatch(setUser(response.user));

//                 return {
//                     success: true,
//                     user: response.user,
//                     token: response.token,
//                     redirectTo: response.redirectTo,
//                 };
//             } catch (err) {
//                 const message =
//                     err?.response?.data?.message ||
//                     err?.response?.data?.error ||
//                     err?.message ||
//                     'Login failed';

//                 dispatch(setError(message));

//                 return {
//                     success: false,
//                     error: message,
//                 };
//             } finally {
//                 dispatch(setLoading(false));
//             }
//         },
//         [dispatch]
//     );

//     const logout = useCallback(async () => {
//         try {
//             await authService.logout();
//         } catch {
//         } finally {
//             dispatch(logoutAction());
//         }
//     }, [dispatch]);

//     const checkAuth = useCallback(() => {
//         const storedToken = localStorage.getItem('authToken');
//         if (storedToken && !isAuthenticated) {
//             dispatch(setToken(storedToken));
//         }
//     }, [dispatch, isAuthenticated]);

//     return {
//         user,
//         token,
//         isAuthenticated,
//         loading,
//         error,
//         login,
//         logout,
//         checkAuth,
//     };
// };
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setUser,
  setToken,
  setPermissions,
  setLoading,
  setError,
  logout as logoutAction,
} from '../store/slices/authSlice';
import { authService } from '../api/services/auth.service';

export const useAuth = () => {
  const dispatch = useDispatch();
  const { user, token, permissions, isAuthenticated, loading, error } = useSelector(
    (state) => state.auth
  );

  const login = useCallback(
    async (credentials) => {
      try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        const response = await authService.login(credentials);

        dispatch(setToken(response.token));
        dispatch(setUser(response.user));
        dispatch(setPermissions(response.permissions || {}));

        return {
          success: true,
          user: response.user,
          token: response.token,
          permissions: response.permissions || {},
          redirectTo: response.redirectTo,
        };
      }  catch (err) {
  // authService.login() now throws a normalized Error with
  // .message / .status / .data already set — no need to dig into
  // err.response here.
  const message = err?.message || 'Login failed';
  const status = err?.status;

  dispatch(setError(message));

  return {
    success: false,
    status,
    error: message,
    message,
    data: err?.data,
  };
} finally {
        dispatch(setLoading(false));
      }
    },
    [dispatch]
  );

  const logout = useCallback(async () => {
    try {
      await authService.logout();
    } catch {
    } finally {
      dispatch(logoutAction());
    }
  }, [dispatch]);

  const checkAuth = useCallback(() => {
    const storedToken = localStorage.getItem('authToken');
    const storedUser = authService.getCurrentUser();
    const storedPermissions = authService.getPermissions();

    if (!storedToken) {
      dispatch(logoutAction());
      return;
    }

    dispatch(setToken(storedToken));
    dispatch(setUser(storedUser || null));
    dispatch(setPermissions(storedPermissions || {}));
  }, [dispatch]);

  const hasPermission = useCallback(
    (permissionKey) => permissions?.[permissionKey] === true,
    [permissions]
  );

  return {
    user,
    token,
    permissions,
    isAuthenticated,
    loading,
    error,
    login,
    logout,
    checkAuth,
    hasPermission,
  };
};